import { Tab } from '../../../../../../views/team/reports';

export default {
  tabs: {
    [Tab.General]: 'General',
    [Tab.SignedLive]: 'Firmado / Activo',
    [Tab.MRR]: 'MRR',
    [Tab.CollectedCommission]: 'Comisión',
  },
};
